import React, { useState } from 'react';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch('https://formspree.io/f/mvzbdoqv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          email
        })
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };
  return <footer className="bg-gray-900 text-white pt-16 pb-8 border-t border-gray-800" data-id="element-115">
      <div className="container mx-auto px-4" data-id="element-116">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-117">
          <div className="col-span-1 md:col-span-1" data-id="element-118">
            <div className="flex items-center space-x-2 mb-6" data-id="element-119">
              <div className="h-8 w-8 bg-gradient-to-br from-blue-600 to-purple-600 rounded-md flex items-center justify-center" data-id="element-120">
                <span className="text-white text-[10px] font-bold" data-id="element-121">AI</span>
              </div>
              <span className="text-lg font-bold" data-id="element-122">Swedenmark AI</span>
            </div>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-123">
              AI Automation & Growth Consulting for mid-market companies. We
              turn intelligence into competitive advantage.
            </p>
          </div>

          <div data-id="element-124">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-500 mb-6" data-id="element-125">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-126">
              <li data-id="element-127">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-128">
                  About Us
                </a>
              </li>
              <li data-id="element-129">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-130">
                  Services
                </a>
              </li>
              <li data-id="element-131">
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-132">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-133">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-500 mb-6" data-id="element-134">
              Services
            </h3>
            <ul className="space-y-3" data-id="element-135">
              <li data-id="element-136">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-137">
                  Process Automation
                </a>
              </li>
              <li data-id="element-138">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-139">
                  Sales Acceleration
                </a>
              </li>
              <li data-id="element-140">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-141">
                  Marketing Intelligence
                </a>
              </li>
              <li data-id="element-142">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-143">
                  Operational Analytics
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-144">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-500 mb-6" data-id="element-145">
              Stay Ahead
            </h3>
            <p className="text-gray-400 mb-4 text-sm" data-id="element-146">
              Get our latest insights on AI strategy for mid-market growth.
            </p>
            {status === 'success' ? <div className="bg-green-900/40 border border-green-700 text-green-300 rounded-lg px-4 py-3 text-sm" data-id="element-147">
                ✓ You're on the list — thanks for subscribing!
              </div> : <form onSubmit={handleSubscribe} className="flex flex-col gap-2" data-id="element-148">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Work email" required className="px-4 py-2 bg-gray-800 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 border border-gray-700 text-sm" data-id="element-149" />
                <button type="submit" disabled={status === 'submitting'} className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${status === 'submitting' ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'} text-white`} data-id="element-150">
                  {status === 'submitting' ? 'Subscribing...' : 'Subscribe'}
                </button>
                {status === 'error' && <p className="text-red-400 text-xs" data-id="element-151">
                    Something went wrong. Please try again.
                  </p>}
              </form>}
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-152">
          <p className="text-gray-500 text-sm" data-id="element-153">
            &copy; {new Date().getFullYear()} Swedenmark AI. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-500" data-id="element-154">
            <a href="#" className="hover:text-white transition-colors" data-id="element-155">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-156">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}